import {
  USER_LIST,
  CREDIT_UPDATE,
  LOGIN_SUCCESS,
  LOGOUT,
  PAGE_LOAD,
  SAVE_CONTENT,
  ADD_REAL_TIME_NOTIFICATION,
  SEED_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  CLEAR_NOTIFICATIONS,
  BUMP_QUOTE_LIST_REFRESH,
  FETCH_TAGS,
  CREATE_TAG,
  UPDATE_TAG,
  DELETE_TAG,
  ASSIGN_TAG,
  REMOVE_TAG
} from "./constants";

export const loginSuccess = (user, token) => ({
  type: LOGIN_SUCCESS,
  payload: { user, token },
});

export const updateCredit = (newCredit) => ({
  type: CREDIT_UPDATE,
  payload: newCredit
})

export const logout = () => ({
  type: LOGOUT,
});

export function getUserList() {
  return {
    type: USER_LIST,
  };
}

export function loadPage(bool) {
  return {
    type: PAGE_LOAD,
    payload: bool,
  }
}

export const saveContent = (content) => ({
  type: SAVE_CONTENT,
  payload: content,
});

export const addRealTimeNotification = (notification) => ({
  type: ADD_REAL_TIME_NOTIFICATION,
  payload: notification,
});

// Seed the bell with notification history fetched from the API. The SSE stream
// intentionally sends no backlog on connect (sseHandlers.js:35), so without
// this the dropdown is empty until a live event arrives.
export const seedNotifications = (notifications) => ({
  type: SEED_NOTIFICATIONS,
  payload: notifications,
});

export const markNotificationRead = (notificationId) => ({
  type: MARK_NOTIFICATION_READ,
  payload: notificationId,
});

export const markAllNotificationsRead = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ,
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

export const bumpQuoteListRefresh = (payload = {}) => ({
  type: BUMP_QUOTE_LIST_REFRESH,
  payload,
});

// Tag actions
export const fetchTags = (token, role) => ({
  type: FETCH_TAGS,
  payload: { token, role },
});

export const createTag = (token, role, name, color) => ({
  type: CREATE_TAG,
  payload: { token, role, name, color },
});

export const updateTag = (token, role, tagId, name, color) => ({
  type: UPDATE_TAG,
  payload: { token, role, tagId, name, color },
});

export const deleteTag = (token, role, tagId) => ({
  type: DELETE_TAG,
  payload: { token, role, tagId },
});

export const assignTag = (token, role, tagId, quoteId) => ({
  type: ASSIGN_TAG,
  payload: { token, role, tagId, quoteId },
});

export const removeTag = (token, role, tagId, quoteId) => ({
  type: REMOVE_TAG,
  payload: { token, role, tagId, quoteId },
});;